<template>
  <div class="wrapper">
    <h1 class="underline-header">新規会員登録</h1>
    <div class="form-wrapper">
      <p class="intro-text p-standard-paragraph u-taC">会員登録すると、お得な物件情報をお届けします。</p>
      <div class="c-merit">
        <ul class="c-merit__meritList">
          <li class="c-merit__meritList__item">
            <div class="c-merit__meritList__circle">
              1
            </div>
            <div class="c-merit__meritList__body">
              <div class="c-merit__meritList__body__text">
                <h2>{{modifiableText.reg1_heading}}</h2>
                <p>{{modifiableText.reg1_text}}</p>
              </div>
              <figure v-if="modifiableText.reg1_img" class="c-merit__meritList__body__image">
                <img :src="modifiableText.reg1_img.url" />
              </figure>
            </div>
          </li>
          <li class="c-merit__meritList__item">
            <div class="c-merit__meritList__circle">
              2
            </div>
            <div class="c-merit__meritList__body">
              <div class="c-merit__meritList__body__text">
                <h2>{{modifiableText.reg2_heading}}</h2>
                <p>{{modifiableText.reg2_text}}</p>
              </div>
              <figure v-if="modifiableText.reg2_img" class="c-merit__meritList__body__image">
                <img :src="modifiableText.reg2_img.url" />
              </figure>
            </div>
          </li>
          <li class="c-merit__meritList__item">
            <div class="c-merit__meritList__circle">
              3
            </div>
            <div class="c-merit__meritList__body">
              <div class="c-merit__meritList__body__text">
                <h2>{{modifiableText.reg3_heading}}</h2>
                <p>{{modifiableText.reg3_text}}</p>
              </div>
              <figure v-if="modifiableText.reg3_img" class="c-merit__meritList__body__image">
                <img :src="modifiableText.reg3_img.url" />
              </figure>
            </div>
          </li>
        </ul>
        <p class="c-merit__middleText">会員登録しておトクに家探し</p>
        <p class="c-merit__bottomText">↓↓↓メールアドレスだけで無料会員登録↓↓↓</p>
      </div>

      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(onSubmit)">
          <div class="email-field p-standard-field">
            <label class="p-form-title" for="email">メールアドレス</label>
            <div class="input-wrapper">
              <ValidatedInput :expandedTooltip="true" type="email" autocomplete="email" id="email" name="メールアドレス" v-model="email" rules="required|email"/>
            </div>
          </div>
          <p v-if="err.isErr" class="p-errmsg">
            <span>
              <img
                src="@/assets/attention.png"
                alt="エラー"
                width="22"
                height="22"
              />
            </span>
            {{err.msg}}
          </p>
          <common-agree-check v-model="agreeChecked" @clear="agreeTooltip = false" :error="agreeTooltip" :disabled="submitting" class="agree-check-wrapper">
            個人情報保護方針と会員規約に同意のうえ送信してください。
          </common-agree-check>
          <div class="policy-wrapper">
            <a href="https://ki-group.co.jp/policy/" target="_blank" class="c-privacy-policy">
              <img id="my-page-icon" src="@/assets/icon-document.png" alt="">
              <p>個人情報保護方針（プライバシーポリシー）</p>
            </a>
            <a href="https://ki-group.co.jp/member/agreement/" target="_blank" class="c-contract">
              <img id="my-page-icon" src="@/assets/icon-document.png" alt="">
              <p>会員規約（利用規約）</p>
            </a>
          </div>
          <div>
            <input
              v-if="submitting"
              class="submit-button disabled-button square-button"
              type="submit"
              name="login"
              disabled
              value="送信中です・・・"
            />
            <input
              v-else-if="!agreeChecked"
              @click="showAgreeTooltip"
              class="submit-button disabled-button square-button"
              type="button"
              name="login"
              value="上記に同意して仮登録メールを送信"
            />
            <input
              v-else
              class="submit-button square-button"
              type="submit"
              name="login"
              value="上記に同意して仮登録メールを送信"
            />
          </div>
          <div class="p-form p-form--single p-mail-warning">
            <div class="center-wrapper">
              <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
              <p>
              メール受信制限をされている方は、「ki-group.co.jp」からの受信許可設定をしてください。
              </p>
            </div>
          </div>
        </form>
      </ValidationObserver>
    </div>

    <a @click="navigateToLogin" id="go-login-wrapper">
      <img class="my-page-icon" src="@/assets/icon-login.png" alt="">
      <p class="c-go-login">会員登録済みの方はこちらからログイン</p>
    </a>

    <withdraw-mailer class="c-mailer-link"/>

  </div>
</template>

<script>
import MixinAPIs from '@/plugins/mixin-api';
import MixinMeta from '@/plugins/mixin-meta';

import { signUp, signIn } from '@/utils/auth';
import ValidatedInput from '@/components/common/validation/ValidatedInput';
import { ValidationObserver } from 'vee-validate';
import ValidationTooltip from '@/components/common/validation/ValidationTooltip';
import CommonAgreeCheck from '@/components/parts/CommonAgreeCheck';
import WithdrawMailer from '@/components/common/WithdrawMailer';

export default {
  name: 'MemberRegist',
  mixins: [MixinAPIs, MixinMeta],
  components: {
    ValidatedInput,
    ValidationObserver,
    CommonAgreeCheck,
    ValidationTooltip,
    WithdrawMailer,
  },
  data() {
    return {
      err: {
        isErr: false,
        msg: '',
      },
      modifiableText: {},
      agreeTooltip: false,
      agreeChecked: false,
      email: '',
      submitting: false,
    };
  },
  async created() {
    this.metaSetForDefault('signUp');
    const tmp = await this.getModifiableTextList();
    this.modifiableText = tmp.data;
    // Footer表示フラグ更新
    await this.$store.commit('setFooterDisplayFlag');
  },
  methods: {
    navigateToForm() {
      this.$emit('updated', 'form');
    },
    navigateToSent() {
      this.$emit('updated', 'sent');
    },
    hideAgreeTooltip() {
      this.agreeTooltip = false;
    },
    showAgreeTooltip() {
      this.agreeTooltip = true;
    },
    navigateToLogin() {
      signIn();
    },
    async onSubmit() {
      if (!this.agreeChecked) {
        return;
      }
      this.err.isErr = false;
      this.err.msg = '';
      try {
        this.submitting = true;
        await signUp(this.email.trim());
        this.navigateToSent();
      } catch (e) {
        this.err.isErr = true;
        this.err.msg = e.message;
      } finally {
        this.submitting = false;
      }
    },
  },
};
</script>

<!-- Add 'scoped' attribute to limit CSS to this component only -->
<style scoped lang="scss">
@charset "UTF-8";
@import url(https://stackpath.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css);
@import "../../../assets/style/parts_responsive.scss";
.form-wrapper {
  padding: 16px 12px;
}

.wrapper {
  height: 640px;
}

.c-go-login {
  margin-left: 8px;
  text-align: right;
  font-size: 14px;
}


.p-mail-warning {
  display: flex;
  margin: 34px 0 12px 0;
  line-height:22px;
  font-size: 14px;
  justify-content: center;

  .center-wrapper {
    display: flex;
  }

  .fa-exclamation-triangle {
    margin-right: 12px;
    font-size: 20px;
    color: #ffcc00;
  }
}

.c-merit {
    width: 100vw;
    margin: 0 0 30px -147px;
    background-color: #FFF;
  &__meritList {
    width: 100%;
    max-width: 520px;
    margin: auto;
    padding-top: 21px;
    &__item {
      display:flex;
      margin-bottom:20px;
    }
    &__circle {
      width: 35px;
      height: 35px;
      color: #E83532;
      font-size:20px;
      border: 2px solid #E83532;
      border-radius: 50%;/*角丸*/
      flex-shrink: 0;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    &__body {
      display: flex;
      width:100%;
      justify-content: space-between;
      &__text {
        h2 {
          padding:10px 20px;
          font-size:16px;
          color: #E83532;
        }
        p {
          padding:10px 20px;
          line-height: 1.5em;
        }
      }
      &__image {
        width: 100px;
        height: 100px;
        flex-shrink: 0;
        border: 1px solid #CCC;
        background-color: #DDD;
        display: flex;
        justify-content: center;
        align-items: center;
        img {
          width:100%;
        }
      }
    }
  }
  &__middleText {
    color: #E83532;
    font-size:18px;
    font-weight:bold;
    text-align: center;
    margin-bottom: 20px;
  }
  &__bottomText {
    color: #E83532;
    font-size:16px;
    text-align: center;
    padding-bottom: 20px;
  }
}

label {
  font-size: 14px;
}

.input-wrapper {
  margin-top: 12px;
}

.p-standard-field {
  max-width: 492px;
}

.email-field {
  margin-top: 22px;
}

.submit-button {
  margin-top: 12px;
}

#go-login-wrapper {
  display: flex;
  align-items: center;
  margin: auto;
  margin-top: 26px;
  width: 299px;
  color: red;

  .my-page-icon {
    height:28px;
    width:28px;
  }
}
.policy-wrapper {
  display: flex;
  flex-wrap: wrap;
  justify-content: start;
  align-items: center;
}
.c-contract,
.c-privacy-policy {
  font-size: 14px;
  padding-left: 4px;
  margin-top: 8px;
  display: flex;
  align-items: center;

  p {
    margin-left: 4px;
  }
}

.c-mailer-link {
  text-align: center;
  margin-top: 32px;
}

.agree-check-wrapper {
  margin-top: 26px;
}

.u-taC {
  text-align: center;
}
.u-mT10 {
  margin-top: 10px;
}

@media(min-width: 640px) {
  .wrapper {
    padding: 30px 40px;
  }

  .input-wrapper {
    width: 292px;
  }

  .p-standard-field label {
    width: 26%;
  }

  .underline-header {
    max-width: 720px;
  }

  .intro-text {
    font-size: 18px;
  }

  #go-login-wrapper {
    margin-top: 10px;
  }
  .policy-wrapper {
    justify-content: center;
  }
}
.p-standard-paragraph {
  padding-bottom: 16px;
}

@media(min-width: 1000px) {
  .input-wrapper {
    width: 360px;
  }

  .wrapper {
    padding: 30px 120px;
  }
}
@media(max-width: 1000px) {
  .c-merit {
    margin: 0 0 30px -67px;
  }
}

@media(max-width: 640px) {
  .c-merit {
    margin: 0 0 0 -12px;;
    &__meritList {
      &__item {
        flex-direction: column;
        align-items: center;
      }
      &__circle {
        margin-bottom:20px;
      }
      &__body {
        flex-direction: column-reverse;
        align-items: center;
        &__text {
          width:100%;
          margin-top: 10px;
          h2 {
            width:100%;
          }
          p {
            width:100%;
          }
        }
        &__image {
          img {
          }
        }
      }
    }
    &__middleText {
    }
    &__bottomText {
    }
  }
}
</style>
